import React, { useState } from 'react';
import { downloadJson, downloadCsv } from '../services/exportService';

interface ExportButtonsProps {
  documentId: string;
  status: string;
}

/**
 * Export buttons for downloading document data.
 * Only shown when document status is 'extracted' or 'validated'.
 */
const ExportButtons: React.FC<ExportButtonsProps> = ({ documentId, status }) => {
  const [isExporting, setIsExporting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Only show export buttons for extracted or validated documents
  if (!['extracted', 'validated'].includes(status)) {
    return null;
  }

  const handleExportJson = async () => {
    setIsExporting(true);
    setError(null);
    try {
      await downloadJson(documentId);
    } catch (err) {
      setError('Erreur lors de l\'export JSON');
      console.error('Export JSON error:', err);
    } finally {
      setIsExporting(false);
    }
  };

  const handleExportCsv = async () => {
    setIsExporting(true);
    setError(null);
    try {
      await downloadCsv(documentId);
    } catch (err) {
      setError('Erreur lors de l\'export CSV');
      console.error('Export CSV error:', err);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2">
        <button
          onClick={handleExportJson}
          disabled={isExporting}
          className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
        >
          {isExporting ? 'Export...' : 'Export JSON'}
        </button>
        <button
          onClick={handleExportCsv}
          disabled={isExporting}
          className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
        >
          {isExporting ? 'Export...' : 'Export CSV'}
        </button>
      </div>
      {error && <p className="text-red-600 text-sm">{error}</p>}
    </div>
  );
};

export default ExportButtons;
